import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-score-icon',
  standalone: true,
  template: `
    @if(score === -2) {
      <img class="text-center" src="/assets/img/emoji-monocle.svg" alt="C" width="40" height="40" />
    } @if(score === -1) {
      <img class="text-center" src="/assets/img/emoji-slightly-smiling.svg" alt="B" width="40" height="39" />
    } @if(score === 0) {
      <img class="text-center" src="/assets/img/emoji-grinning.svg" alt="A" width="41" height="39" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScoreIconComponent {
  @Input() score: number;
}
